<template>
  <Modal title="一括設定" @close="onClose">
    <FormGrid class="form">
      <dt>ランチ</dt>
      <dd class="section">
        <TimeInput v-model="setLunchStart" :startHour="6" :length="25" clearButton small />
        〜
        <TimeInput v-model="setLunchEnd" :startHour="6" :length="25" clearButton small />
      </dd>
      <dt>ディナー</dt>
      <dd class="section">
        <TimeInput v-model="setDinnerStart" :startHour="6" :length="25" clearButton small />
        〜
        <TimeInput v-model="setDinnerEnd" :startHour="6" :length="25" clearButton small />
      </dd>
    </FormGrid>
    <template #footer-center>
      <Button @click="onClose">戻る</Button>
      <Button @click="onSelect" primary>
        一括設定
      </Button>
    </template>
  </Modal>
</template>

<script>
import Button from '@/components/atoms/Button'
import Modal from '@/components/molecules/Modal'
import FormGrid from '@/components/molecules/FormGrid'
import TimeInput from '@/components/molecules/TimeInput'

export default {
  name: 'BusinesshourModal',
  components: {
    Button,
    Modal,
    FormGrid,
    TimeInput,
  },
  data() {
    return {
      setLunchStart: null,
      setLunchEnd: null,
      setDinnerStart: null,
      setDinnerEnd: null,
    }
  },
  watch: {
    setLunchStart(hour) {
      if (hour === null) this.setLunchEnd = null
      if (this.setLunchEnd < hour) this.setLunchEnd = hour
    },
    setLunchEnd(hour) {
      if (hour === null) this.setLunchStart = null
      if (hour < this.setLunchStart) this.setLunchStart = hour
    },
    setDinnerStart(hour) {
      if (hour === null) this.setDinnerEnd = null
      if (this.setDinnerEnd < hour) this.setDinnerEnd = hour
    },
    setDinnerEnd(hour) {
      if (hour === null) this.setDinnerStart = null
      if (hour < this.setDinnerStart) this.setDinnerStart = hour
    },
  },
  methods: {
    onSelect() {
      this.$emit('select', {
        lunchStart: this.setLunchStart,
        lunchEnd: this.setLunchEnd,
        dinnerStart: this.setDinnerStart,
        dinnerEnd: this.setDinnerEnd,
      })
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.section {
  align-items: center;
  box-sizing: border-box;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: center;
}

.form {
  align-items: center;
  grid-gap: 24px;
  grid-template-columns: 88px 1fr;

  > dt {
    font-size: 21px;
    font-weight: normal;
    padding: 0;
  }
}

>>> .time-input {
  width: 136px;
}
</style>
